// Billing currencies - includes all currencies supported by billing system
export const BILLING_CURRENCIES = ['USD', 'SEK', 'EUR', 'GBP', 'CAD', 'AUD', 'PLN', 'CHF', 'NOK'] as const
export type BillingCurrency = (typeof BILLING_CURRENCIES)[number]

// Tariff currencies - subset of billing currencies supported by custom tariff builder
export const TARIFF_CURRENCIES = ['USD', 'SEK', 'EUR'] as const
export type TariffCurrency = (typeof TARIFF_CURRENCIES)[number]

// Agreement currencies - subset of billing currencies supported by agreements
export const AGREEMENT_CURRENCIES = ['USD', 'SEK', 'EUR', 'GBP', 'PLN', 'CHF', 'NOK'] as const
export type AgreementCurrency = (typeof AGREEMENT_CURRENCIES)[number]
